import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Room} from '../../../classes/Room';
import {Subject} from 'rxjs';
import {Office} from '../../../classes/Office';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {OfficeService} from '../../../services/office.service';
import {RoomType} from '../../../enums/RoomType';
import {RoomClosure} from '../../../classes/RoomClosure';
import {RoomService} from '../../../services/room.service';

@Component({
  selector: 'app-roomclosure-edit',
  styleUrls: ['./roomclosure-edit.component.scss'],
  templateUrl: './roomclosure-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RoomClosureEditComponent implements OnInit {

  @Input() roomClosure: RoomClosure;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  types: string[];
  offices: Office[];
  rooms: Room[];

  public roomClosureForm: FormGroup;
  private dateModel: Date = new Date();
  private stringDateModel: string = new Date().toString();

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private officeService: OfficeService,
              private roomService: RoomService) {}

  ngOnInit(): void {

    this.types = Object.keys(RoomType);

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });

    this.roomService.getAll().subscribe({
      next: (response: Room[]) => this.rooms = response,
      error: err => console.log(err.error) // TODO handle error
    });

    if (this.roomClosure) {
      this.roomClosureForm = this.formBuilder.group({
        id: [this.roomClosure.id],
        office: [this.roomClosure.room.officeId],
        roomId: [this.roomClosure.room.id, Validators.required],
        start: [this.roomClosure.start, Validators.required],
        end: [this.roomClosure.end, Validators.required]
      });
    } else {
      this.roomClosureForm = this.formBuilder.group({
        id: [''],
        office: [''],
        roomId: ['', Validators.required],
        start: [new Date().setMinutes(0, 0, 0), {validators: Validators.required, DateTimeValidator}],
        end: [new Date().setMinutes(0, 0, 0), {validators: Validators.required, DateTimeValidator}],
      });
    }

    this.roomClosureForm.controls.office.valueChanges.subscribe((value) => {
      this.roomService.getByOffice(value).subscribe((response) => {
        this.rooms = response;
        this.roomClosureForm.controls.roomId.setValue(null);
      });
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}

export const DateTimeValidator = (fc: FormControl) => {
  const date = new Date(fc.value);
  const isValid = !isNaN(date.valueOf());
  return isValid ? null : {
    isValid: {
      valid: false
    }
  };
};
